export default __webpack_public_path__ + "static/media/blend-table.bff5bec0.svg";